import style from "../accountActions.module.css";
import {Link} from "preact-router/match";
import {h} from "preact";

const DropdownContent = (props) => {
    // Destructured props
    const {
        data,
        highContrast,
        signOut
    } = props;

    return !data.isSignedIn ? (
        <ul
            className={`relative divide divide-y ${highContrast ? "grayBackground highLabelFourth" : ""}`}
            data-testid="account-actions-ul-not-logged"
        >
            <li className={style.dropdownItem}>
                <Link
                    href={"/entre"}
                    className={`
                        w-full h-full flex flex-row items-center justify-center text-[#666] 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                    data-testid={`login-link`}
                >
                    Entre / Cadastre-se
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <Link
                    href={"/entre"}
                    className={`
                        w-full h-full flex flex-row items-center justify-center text-[#666] 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Meus pedidos
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <Link
                    href={"/entre"}
                    className={`w-full h-full flex flex-row items-center justify-center text-[#666] 
                    ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}`}
                >
                    Meus dados
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <Link
                    href={"/entre"}
                    className={`
                        w-full h-full flex flex-row items-center justify-center text-[#666] 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Endereços
                </Link>
            </li>
        </ul>
    ) : (
        <ul className={`relative divide divide-y ${highContrast ? "grayBackground hover:highLabelFourth" : ""}`} data-testid="account-actions-ul-logged">
            <li className={style.dropdownItem}>
                <Link
                    href={"/meus-pedidos"}
                    className={`
                        w-full h-full flex flex-row items-center justify-center 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Meus pedidos
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <Link
                    href={"/editar-conta"}
                    className={`
                        w-full h-full flex flex-row items-center justify-center 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Meus dados
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <Link
                    href={"/enderecos"}
                    className={`
                        w-full h-full flex flex-row items-center justify-center 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Endereços
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <button
                    type={"button"}
                    onClick={() => signOut().then(() => {})}
                    className={`
                        w-full h-full flex flex-row items-center justify-center uppercase 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Sair
                </button>
            </li>
        </ul>
    )
}

export default DropdownContent;
